import { render, staticRenderFns } from "./OxygenGivenCheck.vue?vue&type=template&id=24ffb91c&scoped=true&"
import script from "./OxygenGivenCheck.vue?vue&type=script&lang=js&"
export * from "./OxygenGivenCheck.vue?vue&type=script&lang=js&"
import style0 from "./OxygenGivenCheck.vue?vue&type=style&index=0&id=24ffb91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ffb91c",
  null
  
)

export default component.exports